module.exports = __webpack_public_path__ + "static/img/Woman Bags.c6b7b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Woman Bags.jpg
// module id = bWvW
// module chunks = 1